import { Typography } from "@mui/material";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { useSearchParams } from "react-router-dom";

import { useTeaching } from "../hooks/useTeaching";

export function LessonNavigation() {
	const { summary, currentBooking } = useTeaching();
	const [, setSearchParams] = useSearchParams();

	if (!currentBooking || !summary) {
		return null;
	}

	const index = summary.bookings.findIndex(
		(booking) => booking.id === currentBooking.id,
	);

	if (index === -1) {
		return null;
	}

	return (
		<div className="lesson-navigation-container item-separator-big">
			{index > 0 && (
				<div
					className="lesson-navigation-button"
					onClick={() => {
						setSearchParams((prev) => {
							prev.set("class", summary.bookings[index - 1].id.toString());
							return prev;
						});
					}}>
					<FaChevronLeft className="normal-icon" />
					<Typography className="normal-text">Previous Class</Typography>
				</div>
			)}
			<div style={{ flex: 1 }} />
			{index < summary.bookings.length - 1 && (
				<div
					className="lesson-navigation-button"
					onClick={() => {
						setSearchParams((prev) => {
							prev.set("class", summary.bookings[index + 1].id.toString());
							return prev;
						});
					}}>
					<Typography className="normal-text">Next Class</Typography>
					<FaChevronRight className="normal-icon" />
				</div>
			)}
		</div>
	);
}
